import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ServicesHero from "./sections/ServicesHero";
import ServiceDetails from "./sections/ServiceDetails";
import InsuranceAndFunding from "./sections/InsuranceAndFunding";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ServicesHero />
      <ServiceDetails />
      <InsuranceAndFunding />
      <Footer />
    </div>;
}